// 일별/주별/월별, 구간별/누적 등 여러 탭에서 반복되던 세그먼트 토글 버튼 그룹을 하나로
// 공유(2026-07-16, "탭마다 똑같은 토글이 각자 따로 있다" 중복 지적 반영).
//
// disabled(2026-07-18): 뷰 전환 시 컨트롤을 숨기는 대신 흐리게 두면 나머지 컨트롤들의
// 위치가 안 밀린다("화면 구성이 막 변하면 안 됨" 피드백) — 지금 뷰에서 의미 없는 토글은
// 사라지는 게 아니라 비활성으로 자리를 지킨다.
export default function ToggleGroup({ options, value, onChange, disabled = false, disabledTitle }) {
  return (
    <div
      className={`inline-flex rounded-md border border-ink-200 bg-white p-0.5 ${disabled ? "opacity-40" : ""}`}
      title={disabled ? disabledTitle : undefined}
    >
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          onClick={() => onChange(o.id)}
          disabled={disabled}
          className={`rounded px-2.5 py-1.5 text-xs font-medium disabled:cursor-not-allowed ${
            value === o.id ? "bg-brand-600 text-white" : "text-ink-600 hover:bg-ink-100"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
